// @ts-nocheck
import React from "react";
import { Link } from "react-router-dom";
import { WithdrawPageContext } from "./WithdrawPageContext";
import { useWithdrawPageController } from "./useWithdrawPageController";
import WithdrawPageFaq from "./WithdrawPageFaq";
import WithdrawPageSteps12 from "./WithdrawPageSteps12";
import WithdrawPageStep3Overlays from "./WithdrawPageStep3Overlays";
import AddressBookVerificationModals from "./AddressBookVerificationModals";
import { kycGateMessage } from "../../../utils/kycVerified";
import WithdrawPageRecentSection from "./WithdrawPageRecentSection";
import "./withdrawal.css";
import "../TwofactorPage/changeLoginPassword.css";

export default function WithdrawPage({ userDetails = {} }) {
  const ctx = useWithdrawPageController(userDetails);
  const {
    showWithdrawKycGateOverlay,
    withdrawProfileLoading,
    withdrawProfileReady,
    withdrawKycVerified,
    navigate,
    stepperWrapRef,
    railDims,
    isStep2Done,
    isMobile,
  } = ctx;

  return (
    <WithdrawPageContext.Provider value={ctx}>
      <div className={`dashboard_right${showWithdrawKycGateOverlay ? " dashboard_right--kyc-gate" : ""}`}>
        <div className="depositcrypto_lft">
          <div className="deposit_crypto_page_head">
            <h1>Withdraw Crypto</h1>
            {/* <Link to="/asset_managemnet/deposit_fiat" className="deposit_fiat_head_btn">
              Deposit Fiat
              <span className="deposit_fiat_head_arrow" aria-hidden="true">
                <img src="/images/fiatarrow.svg" alt="" aria-hidden="true" />
              </span>
            </Link> */}
          </div>

          <div className="deposit_crypto_block_coin">
            <div ref={stepperWrapRef} className={`deposit_crypto_left${isStep2Done ? " has-step3" : ""}`}>
              <div
                className="deposit-stepper-rail withdraw-stepper-rail"
                aria-hidden="true"
                style={{
                  "--rail-top": `${railDims.top}px`,
                  "--rail-height": `${railDims.height}px`,
                  "--rail-fill": `${railDims.fill || 0}px`,
                }}
              >
                <div className="deposit-stepper-rail__fill" />
              </div>
              <WithdrawPageSteps12 />
              <WithdrawPageStep3Overlays />
              <AddressBookVerificationModals />
            </div>
            {!isMobile ? (
              <div className="deposit_crypto_right">
                <WithdrawPageFaq />
              </div>
            ) : null}
          </div>

          <WithdrawPageRecentSection />

          {isMobile ? (
            <div className="deposit_crypto_right">
              <WithdrawPageFaq />
            </div>
          ) : null}
        </div>
        {withdrawProfileLoading ? (
          <div className="withdraw-kyc-gate-overlay" role="presentation">
            <div
              className="pm-restrictModal withdraw-kyc-gate-modal withdraw-kyc-gate-modal--loading"
              role="status"
              aria-live="polite"
              aria-busy="true"
            >
              <p className="withdraw-kyc-gate-loading__text" style={{ margin: 0 }}>
                Loading your account…
              </p>
            </div>
          </div>
        ) : null}
        {withdrawProfileReady && !withdrawKycVerified ? (
          <div className="withdraw-kyc-gate-overlay" role="presentation">
            <div
              className="pm-restrictModal withdraw-kyc-gate-modal withdraw-kyc-gate-modal--single"
              role="dialog"
              aria-modal="true"
              aria-labelledby="withdraw-kyc-required-title"
            >
              <button
                type="button"
                className="pm-restrictModal__close"
                aria-label="Close"
                onClick={() => navigate(-1)}
              >
                <i className="ri-close-line" aria-hidden="true" />
              </button>
              <div className="pm-restrictModal__art">
                <img className="dark_img" src="/images/security/account_restrictions.svg" alt="" />
                <img className="light_img" src="/images/security/security_risk_vector_light.svg" alt="" />
              </div>
              <h2 id="withdraw-kyc-required-title" className="pm-restrictModal__title">
                Identity verification required
              </h2>
              <p className="pm-restrictModal__text">
                {kycGateMessage(userDetails?.kycVerified)} Open Identification in your profile. When your KYC status is verified, you can complete your withdrawal here.
              </p>
              <div className="pm-restrictModal__actions">
                <button
                  type="button"
                  className="pm-restrictModal__confirm withdraw-kyc-modal__cta withdraw-kyc-modal__cta--solo"
                  // This gate sits above everything (z-index 999999), so open the KYC modal over the dashboard.
                  onClick={() => navigate("/kyc-verification")}
                >
                  Verify now
                </button>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </WithdrawPageContext.Provider>
  );
}
